// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu12/Item.css
// module id = 2030
// module chunks = 0